<template>
	<div class="usuario-gerenciados w-full">
		<div class="flex flex-col mt-10 mb-4">
			<h4 class="subtitle font-bold mb-4">Estrutura de usuários</h4>
			<h5 class="text-base font-normal">
				Informe qual(is) colaborador(es) este usuário gerenciará.
				Selecione abaixo um colaborador para adicioná-lo à estrutura de colaboradores.
				Repita a operação quantas vezes for necessário.
			</h5>
		</div>
		<section class="usuario-gerenciados-adicionar relative mb-3">
			<div class="flex flex-col pb-4 pl-3 pr-4">
				<div class="flex flex-wrap items-end w-full">
					<div class="flex-1 md:mr-3 mr-0">
						<ld-select
							:disabled="!(gerenciaveis && gerenciaveis.length) || disabled"
							parent="#usuario-estrutura-permissao .usuario-gerenciados-adicionar"
							name="gerenciados"
							label="Colaborador"
							:model.sync="gerenciado"
							:list.sync="gerenciaveis"
							:search="searchGerenciaveis"
							:moreData="moreGerenciaveis"
						/>
					</div>

					<!-- <vs-input
						label="Perfil"
						class="w-1/4 mr-3"
						v-model="gerenciadoObj.perfil.nome"
						:disabled="true"
					></vs-input>

					<vs-input
						label="CPF"
						class="w-1/4 mr-3"
						v-model="gerenciadoObj.cpf"
						:disabled="true"
					></vs-input> -->

					<ld-button
						:disabled="!gerenciado || disabled"
						class="button-adicionar-estrutura md:w-1/5 md:mt-0 mt-2 w-full"
						color="success"
						type="filled"
						@click="adicionarUsuario"
					>
						Adicionar
					</ld-button>
				</div>
			</div>
		</section>

		<vs-table
			class="usuario-gerenciados-listar"
			ref="table"
			search
			:data="gerenciadosModel"
			noDataText="Nenhum usuário"
		>
			<div slot="header">
				<h4 class="title">
					Lista de usuários
				</h4>
			</div>

			<template slot="thead">
				<vs-th sort-key="nome">Nome</vs-th>
				<vs-th sort-key="nomePerfil">Perfil</vs-th>
				<vs-th sort-key="cpf">CPF</vs-th>
				<vs-th sort-key="email">E-mail</vs-th>
				<vs-th v-if="!disabled">Ações</vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody>
					<vs-tr
						:data="tr"
						:key="indextr"
						v-for="(tr, indextr) in data"
					>
						<vs-td class="gerenciado-nome">
							<p class="font-medium truncate">
								{{ tr.nome }}
							</p>
						</vs-td>

						<vs-td class="gerenciado-perfil">
							<p>{{ tr.nomePerfil }}</p>
						</vs-td>

						<vs-td class="gerenciado-cpf">
							<p>{{ formatCPF(tr.cpf) }}</p>
						</vs-td>

						<vs-td class="gerenciado-email">
							<p>{{ tr.email }}</p>
						</vs-td>

						<vs-td v-if="!disabled" class="w-24 whitespace-no-wrap">
							<feather-icon
								icon="TrashIcon"
								:svgClasses="`w-5 h-5 ${!perfil.isAdmin ? 'hover:text-danger' : 'opacity-25'} stroke-current`"
								class="ml-2"
								@click="() => removerUsuario(indextr)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
// import EncryptHelper from "../../../../../helpers/EncryptHelper";
import Empresa from "../../../../models/Empresa";
import StringHelper from '../../../../helpers/StringHelper';

export default {
	name: "Gerenciados",
	data() {
		return {
			gerenciaveis: [],
			gerenciado: null,
			limitParam: 20,
			formatCPF: StringHelper.formatCPF
		};
	},
	props: {
		usuarioPk: {
			type: String,
		},
		gerenciados: {
			required: true,
			type: Array
		},
		empresa: {
			required: true
		},
		perfil: {
			required: true
		},
		disabled: {
			required: true
		}
	},
	computed: {
		gerenciadosModel: {
			get() {
				return this.gerenciados.map(gerenciado => {
					return {
						...gerenciado,
						nomePerfil: gerenciado.perfil
							? gerenciado.perfil.nome
							: null
					};
				});
			},
			set(value) {
				this.$emit("update:gerenciados", value);
			}
		},
		gerenciadoObj() {
			const gerenciado = this.gerenciaveis.find(
				gerenciavel => gerenciavel.pk == this.gerenciado
			);

			if (gerenciado) {
				return gerenciado;
			}

			return { perfil: "" };
		}
	},
	methods: {
		async moreGerenciaveis(params) {
			const data = {
				count: 0,
				data: []
			};

			const {
				gerenciaveis,
				totalGerenciaveis
			} = await Empresa.getGerenciaveis(
				this.empresa,
				this.perfil.pk,
				params
			);

			data.count = totalGerenciaveis;
			data.data = gerenciaveis
				.filter(gerenciavel => {
					return gerenciavel.pk != this.usuarioPk;
				})
				.map(gerenciavel => {
					return {
						...gerenciavel,
						text: `${gerenciavel.nome} - ${StringHelper.formatCPF(gerenciavel.cpf)} - ${gerenciavel.perfil.nome}`,
						value: gerenciavel.pk
					};
				});

			return data;
		},
		async searchGerenciaveis(searchValue) {

			const params = {
				limit: this.limitParam,
                search: searchValue
			};

			const {
				gerenciaveis,
			} = await Empresa.getGerenciaveis(
				this.empresa,
				this.perfil.pk,
				params
			);

            return gerenciaveis
				.filter(gerenciavel => {
					return gerenciavel.pk != this.usuarioPk;
				})
				.map(gerenciavel => {
					return {
						...gerenciavel,
						text: `${gerenciavel.nome} - ${StringHelper.formatCPF(gerenciavel.cpf)} - ${gerenciavel.perfil.nome}`,
						value: gerenciavel.pk
					};
				});
        },
		async getGerenciaveis() {
			const loadingGenrenciaveis = this.$vsloading({
				container: ".popup-usuario",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				const { gerenciaveis } = await Empresa.getGerenciaveis(
					this.empresa,
					this.perfil.pk,
					{
						limit: 20
					}
				);

				this.gerenciaveis = gerenciaveis
					.filter(gerenciavel => {
						return gerenciavel.pk != this.usuarioPk;
					})
					.map(gerenciavel => {
						return {
							...gerenciavel,
							text: `${gerenciavel.nome} - ${StringHelper.formatCPF(gerenciavel.cpf)} - ${gerenciavel.perfil.nome}`,
							value: gerenciavel.pk
						};
					});
			} catch (error) {
				console.error(error);
			} finally {
				loadingGenrenciaveis.hide();
			}
		},
		clearGerenciados() {
			this.gerenciadosModel = [];
			this.gerenciaveis = null;
			this.gerenciado = null;
		},
		adicionarUsuario() {
			const exist = this.gerenciados.find(
				gerenciado => gerenciado.pk == this.gerenciadoObj.pk
			);

			if (!exist) {
				this.gerenciados.push({
					...this.gerenciadoObj,
					nomePerfil: this.gerenciadoObj.perfil.nome
				});
			}

			this.gerenciado = null;
		},
		removerUsuario(index) {
			if (!this.perfil.isAdmin) {
				this.gerenciados.splice(index, 1);
			}
		}
	},
	watch: {
		"perfil.pk": function() {
			if (this.perfil.pk) {
				this.clearGerenciados();
				this.getGerenciaveis();
			} else {
				this.clearGerenciados();
			}
		}
	},
	created() {
		if (this.perfil.pk && this.empresa) {
			this.getGerenciaveis();
		}
	}
};
</script>

<style lang="scss" src="./gerenciados.scss"></style>
